import React, { Fragment } from 'react'
import { Intro, MultipleChoice, Voiceover } from 'cvs-core'
import image from '../../assets/images/U2-T1-1-9a.svg'
import voAudio from '../../assets/vo/CVS-HS-SPM-Learn-05-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Before you move on to the post-test questions, let’s check your understanding of what you’ve learned in the module!',
}

const data = [
  {
    inputType: 'radio',
    question: 'Vaping produces water vapor which is not dangerous.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      },
    ],
  },
]

const correctInput = {
  [data[0].question]: 'False',
}

const feedback = {
  success: {
    title: 'You Got It!',
    body:
      'Vaping produces an aerosol that contains chemicals, many of which are toxic.',
  },
  error: {
    title: 'Almost!',
    body:
      'Vaping produces an aerosol that contains chemicals, many of which are toxic.',
  },
}

export default {
  title: 'Question 1',
  path: '/learn/question-1',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="True or False?"
        lead="Before you move on to the post-test questions, let’s check your understanding of what you’ve learned in the module!"
        direction="Select the best answer."
        img={image}
      />
      <MultipleChoice
        data={data}
        feedback={feedback}
        correctInput={correctInput}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/Question1.js